// // ServicesSection.jsx
// import React, { useState } from "react";
// import "./services.mobile.css"; // <-- updated CSS with flip styles

// const ServicesSection = () => {
//   const services = [
//     {
//       icon: "bi-shield-lock",
//       title: "Security & Visitor Pass",
//       desc: "Issue digital entry passes, verify visitors, and track logs.",
//     },
//     {
//       icon: "bi-megaphone",
//       title: "Notices & Announcements",
//       desc: "Publish society-wide notices with delivery & read receipts.",
//     },
//     {
//       icon: "bi-calendar-event",
//       title: "Events & RSVPs",
//       desc: "Create events, manage RSVPs and reminders for residents.",
//     },
//     {
//       icon: "bi-file-earmark-check",
//       title: "Elections & Voting",
//       desc: "Conduct secure society elections with audit trails.",
//     },
//     {
//       icon: "bi-tools",
//       title: "Complaints & Work Orders",
//       desc: "Residents raise tickets, staff resolve with SLAs & updates.",
//     },
//     {
//       icon: "bi-credit-card",
//       title: "Payments & Dues",
//       desc: "Collect maintenance and fees with automated invoicing.",
//     },
    
// {
//       icon: "bi-house-gear", // alt: bi-house or bi-tools for generic services
//       title: "Home & Kitchen Services",
//       desc: "Book plumbers, electricians, cleaners, and kitchen help with tracking.",
//     },

//     // NEW: Quick Drop (Transport)
//     {
//       icon: "bi-truck", 
//       title: "Quick Drop (Transport)",
//       desc: "On-demand pick-up & drop for parcels or errands within the city.",
//     },

//   ];

//   const [flipped, setFlipped] = useState(() => services.map(() => false));
//   const toggleFlip = (i) =>
//     setFlipped((prev) => prev.map((f, idx) => (idx === i ? !f : f)));

//   return (
//     <section id="services" className="py-5">
//       <div className="container">
//         <div className="text-center mb-4">
//           <h2 className="fw-bold text-primary-label">Services</h2>
//           <p className="text-muted">
//             Everything your gated community needs—managed in one place.
//           </p>
//         </div>

//         {/* --- MOBILE (< md): 2×N flip grid --- */}
//         <div className="d-md-none">
//           <div className="srv-grid" role="list" aria-label="Services">
//             {services.map((s, i) => (
//               <button
//                 key={s.title}
//                 type="button"
//                 className={`flip-card ${flipped[i] ? "is-flipped" : ""}`}
//                 onClick={() => toggleFlip(i)}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter" || e.key === " ") {
//                     e.preventDefault();
//                     toggleFlip(i);
//                   }
//                 }}
//                 aria-expanded={flipped[i]}
//                 aria-label={`${s.title} details`}
//               >
//                 <div className="flip-card-inner">
//                   {/* FRONT */}
//                   <div
//                     className="flip-card-face flip-card-front"
//                     aria-hidden={flipped[i]}
//                   >
//                     <div className="srv-icon-wrap text-primary-label" aria-hidden="true">
//                       <i className={`bi ${s.icon} srv-icon`} />
//                     </div>
//                     <h5 className="srv-title">{s.title}</h5>
//                   </div>

//                   {/* BACK */}
//                   <div
//                     className="flip-card-face flip-card-back"
//                     aria-hidden={!flipped[i]}
//                   >
//                    <div> <h6 className="srv-back-title">{s.title}</h6>
//                     <p className="srv-desc text-muted">{s.desc}</p>
//                     <span className="hint">Tap to flip back</span>
                    
// {/* Example inside the desktop card for "Home & Kitchen Services" */}
// <button
//   className="btn btn-sm ms-3 btn-outline-teal btn-sm"
//   type="button"
//   onClick={() => (window.location.href = "/services/book-home")}
// >
//   Book Services
// </button>
// </div>

//                   </div>
                  
//                 </div>
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* --- DESKTOP/TABLET (>= md): original Bootstrap grid --- */}
//         <div className="row g-4 d-none d-md-flex">
//           {services.map((s, i) => (
//             <div key={i} className="col-12 col-sm-6 col-lg-4">
//               <div className="card h-100 shadow-sm">
//                 <div className="card-body">
//                   <div className="d-flex align-items-center mb-2">
//                     <i
//                       className={`bi ${s.icon} text-primary-label fs-3 me-2`}
//                       aria-hidden="true"
//                     ></i>
//                     <h5 className="card-title mb-0">{s.title}</h5>
//                   </div>
//                   <p className="card-text text-muted">{s.desc}</p>
//                 </div>
                

//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default ServicesSection;

// ServicesSection.jsx
import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import "./services.mobile.css"; // compact flip grid + centered icon

const ServicesSection = () => {
  const services = [
        { icon: "bi-house-gear",         title: "Home & Kitchen Services",     desc: "Book plumbers, electricians, cleaners, and kitchen help with tracking.", slug: "home-kitchen" },
    { icon: "bi-truck",              title: "Quick Drop (Transport)",      desc: "On-demand pick-up & drop for parcels or errands within the city.",     slug: "quick-drop" },

    { icon: "bi-shield-lock",        title: "Security & Visitor Pass",    desc: "Issue digital entry passes, verify visitors, and track logs.",           slug: "security" },
    { icon: "bi-megaphone",          title: "Notices & Announcements",     desc: "Publish society-wide notices with delivery & read receipts.",          slug: "notices" },
    { icon: "bi-calendar-event",     title: "Events & RSVPs",              desc: "Create events, manage RSVPs and reminders for residents.",             slug: "events" },
    { icon: "bi-file-earmark-check", title: "Elections & Voting",          desc: "Conduct secure society elections with audit trails.",                  slug: "elections" },
    { icon: "bi-tools",              title: "Complaints & Work Orders",    desc: "Residents raise tickets, staff resolve with SLAs & updates.",          slug: "complaints" },
    { icon: "bi-credit-card",        title: "Payments & Dues",             desc: "Collect maintenance and fees with automated invoicing.",               slug: "payments" },
  ];

  const [flipped, setFlipped] = useState(() => services.map(() => false));

  const flipAt = useCallback((i, next) => {
    setFlipped(prev => prev.map((f, idx) => (idx === i ? next : f)));
  }, []);

  const toggleFlip = useCallback((i) => {
    setFlipped(prev => prev.map((f, idx) => (idx === i ? !f : f)));
  }, []);

  /** Handle clicks on the flip container only if they don't originate from interactive elements. */
  const handleCardClick = useCallback((i) => (e) => {
    if (e.defaultPrevented) return;
    const t = e.target;
    if (
      t instanceof Element &&
      t.closest("a, button, input, textarea, select, label")
    ) {
      // Let interactive element handle the event.
      return;
    }
    toggleFlip(i);
  }, [toggleFlip]);

  /** Keyboard support: Enter/Space flips. Skip if focused element is interactive inside. */
  const handleCardKeyDown = useCallback((i) => (e) => {
    const t = e.target;
    if (
      t instanceof Element &&
      t.closest("a, button, input, textarea, select, label")
    ) {
      return;
    }
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleFlip(i);
    }
  }, [toggleFlip]);

  return (
    <section id="services" className="py-5">
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary-label">Services</h2>
          <p className="text-muted">
            Everything your gated community needs—managed in one place.
          </p>
        </div>

        {/* --- MOBILE (< md): 2×N flip grid --- */}
        <div className="d-md-none">
          <div className="srv-grid-compact" role="list" aria-label="Services">
            {services.map((s, i) => {
              const hintId = `srv-${i}-hint`;
              const liveId = `srv-${i}-live`;
              const colorClass = `srv-${(i % 6) + 1}`;

              return (
                <div key={s.slug} role="listitem">
                  {/* SR-only guidance & status */}
                  <span id={hintId} className="visually-hidden">
                    Press Enter or Space to flip and read a short description.
                  </span>
                  <span id={liveId} className="visually-hidden" aria-live="polite">
                    {flipped[i] ? "Details shown." : "Details hidden."}
                  </span>

                  {/* OUTER FLIP CONTAINER — DIV with role="button" */}
                  <div
                    className={`flip-card srv-flip ${flipped[i] ? "is-flipped" : ""} ${colorClass}`}
                    role="button"
                    tabIndex={0}
                    onClick={handleCardClick(i)}
                    onKeyDown={handleCardKeyDown(i)}
                    aria-expanded={flipped[i]}
                    aria-describedby={`${hintId} ${liveId}`}
                    aria-roledescription="flip card"
                    aria-label={s.title}
                  >
                    <div className="flip-card-inner">
                      {/* FRONT: centered icon + title */}
                      <div className="flip-card-face flip-card-front" aria-hidden={flipped[i]}>
                        <div className="srv-icon-badge icon-wrap icon-animated" aria-hidden="true">
                          <i className={`bi ${s.icon} text-primary-label icon-lg`} />
                        </div>
                        <h5 className="srv-title text-truncate">{s.title}</h5>
                      </div>

                      {/* BACK: description + BOOK link */}
                      <div
                        className="flip-card-face flip-card-back"
                        aria-hidden={!flipped[i]}
                      >
                        <h6 className="srv-back-title">{s.title}</h6>
                        <p className="srv-desc text-muted">{s.desc}</p>

                        {/* IMPORTANT: stop propagation on the link so the container doesn't toggle again */}
                        <Link
                          to={`/services/book/${s.slug}`}
                          className="btn btn-outline-teal btn-sm w-100 mt-1"
                          aria-label={`Book ${s.title}`}
                          onClick={(e) => e.stopPropagation()}
                          onKeyDown={(e) => e.stopPropagation()}
                        >
                          Book Services
                        </Link>

                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm w-100 mt-2"
                          onClick={(e) => {
                            e.stopPropagation();
                            flipAt(i, false);
                          }}
                          onKeyDown={(e) => e.stopPropagation()}
                          aria-label="Flip back"
                        >
                          Back
                        </button>

                        <span className="hint d-block mt-1">Tap to flip back</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* --- DESKTOP/TABLET (≥ md): Bootstrap grid --- */}
        <div className="row g-4 d-none d-md-flex">
          {services.map((s) => (
            <div key={s.slug} className="col-12 col-sm-6 col-lg-4">
              <div className="card h-100 shadow-sm">
                <div className="card-body d-flex flex-column">
                  <div className="d-flex align-items-center mb-2">
                    <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
                      <i className={`bi ${s.icon} text-primary-label fs-5`} aria-hidden="true"></i>
                    </span>
                    <h5 className="card-title mb-0">{s.title}</h5>
                  </div>
                  <p className="card-text text-muted flex-grow-1">{s.desc}</p>
                  <div className="d-flex justify-content-end">
                     <Link
                      to={`/services/book/${s.slug}`}
                      className="btn btn-outline-teal btn-sm"
                      aria-label={`Book ${s.title}`}
                    >
                      Book Services
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ServicesSection;

// // ServicesSection.jsx
// import React, { useState, useCallback } from "react";
// import { Link } from "react-router-dom";
// import "./services.mobile.css"; // compact flip grid + centered icon + overflow fixes

// const ServicesSection = () => {
//   const services = [
//     { icon: "bi-house-gear",  title: "Home & Kitchen Services", desc: "Book plumbers, electricians, cleaners, and kitchen help with tracking.", slug: "home-kitchen" },
//     { icon: "bi-truck",       title: "Quick Drop (Transport)",  desc: "On-demand pick-up & drop for parcels or errands within the city.",       slug: "quick-drop" },
//     { icon: "bi-shield-lock", title: "Security & Visitor Pass",  desc: "Issue digital entry passes, verify visitors, and track logs.",          slug: "security" },
//     { icon: "bi-megaphone",   title: "Notices & Announcements",  desc: "Publish society-wide notices with delivery & read receipts.",          slug: "notices" },
//     { icon: "bi-calendar-event", title: "Events & RSVPs",        desc: "Create events, manage RSVPs and reminders for residents.",             slug: "events" },
//     { icon: "bi-file-earmark-check", title: "Elections & Voting", desc: "Conduct secure society elections with audit trails.",                 slug: "elections" },
//     { icon: "bi-tools",       title: "Complaints & Work Orders", desc: "Residents raise tickets, staff resolve with SLAs & updates.",          slug: "complaints" },
//     { icon: "bi-credit-card", title: "Payments & Dues",          desc: "Collect maintenance and fees with automated invoicing.",               slug: "payments" },
//   ];

//   // Only one card flipped at a time
//   const [activeIndex, setActiveIndex] = useState(null);

//   const handleCardClick = useCallback((i) => (e) => {
//     // If click originates from interactive child, don't toggle
//     const t = e.target;
//     if (t instanceof Element && t.closest("a, button, input, textarea, select, label")) return;

//     setActiveIndex((prev) => (prev === i ? null : i));
//   }, []);

//   const handleCardKeyDown = useCallback((i) => (e) => {
//     const t = e.target;
//     if (t instanceof Element && t.closest("a, button, input, textarea, select, label")) return;
//     if (e.key === "Enter" || e.key === " ") {
//       e.preventDefault();
//       setActiveIndex((prev) => (prev === i ? null : i));
//     }
//   }, []);

//   return (
//     <section id="services" className="py-5">
//       <div className="container">
//         <div className="text-center mb-4">
//           <h2 className="fw-bold text-primary-label">Services</h2>
//           <p className="text-muted">Everything your gated community needs—managed in one place.</p>
//         </div>

        // {/* --- MOBILE (< md): 2×N flip grid --- */}
        // <div className="d-md-none">
        //   <div className="srv-grid-compact" role="list" aria-label="Services">
        //     {services.map((s, i) => {
        //       const colorClass = `srv-${(i % 6) + 1}`;
        //       const isFlipped = activeIndex === i;

        //       return (
        //         <div key={s.slug} role="listitem">
        //           {/* SR-only hint + status */}
        //           <span id={`srv-${i}-hint`} className="visually-hidden">
        //             Press Enter or Space to flip and read a short description.
        //           </span>
        //           <span id={`srv-${i}-live`} className="visually-hidden" aria-live="polite">
        //             {isFlipped ? "Details shown." : "Details hidden."}
        //           </span>

        //           {/* OUTER FLIP CONTAINER — DIV to avoid nested button issues */}
        //           <div
        //             className={`flip-card srv-flip ${isFlipped ? "is-flipped" : ""} ${colorClass}`}
        //             role="button"
        //             tabIndex={0}
        //             onClick={handleCardClick(i)}
        //             onKeyDown={handleCardKeyDown(i)}
        //             aria-expanded={isFlipped}
        //             aria-describedby={`srv-${i}-hint srv-${i}-live`}
        //             aria-roledescription="flip card"
        //             aria-label={s.title}
        //           >
        //             <div className="flip-card-inner">
        //               {/* FRONT (centered icon + title) */}
        //               <div className="flip-card-face flip-card-front" aria-hidden={isFlipped}>
        //                 <div className="srv-icon-badge icon-wrap icon-animated" aria-hidden="true">
        //                   <i className={`bi ${s.icon} text-primary-label icon-lg`} />
        //                 </div>
        //                 <h5 className="srv-title">{s.title}</h5>
        //               </div>

        //               {/* BACK (clamped text + CTA) */}
        //               <div
        //                 className="flip-card-face flip-card-back"
        //                 aria-hidden={!isFlipped}
        //               >
        //                 <h6 className="srv-back-title">{s.title}</h6>

        //                 {/* Clamp text so it never exceeds the box */}
        //                 <p className="srv-desc text-muted">{s.desc}</p>

        //                 <div className="srv-actions">
        //                   <Link
        //                     to={`/services/book/${s.slug}`}
        //                     className="btn btn-outline-teal btn-sm w-100"
        //                     aria-label={`Book ${s.title}`}
        //                     onClick={(e) => e.stopPropagation()}
        //                     onKeyDown={(e) => e.stopPropagation()}
        //                   >
        //                     Book Services
        //                   </Link>

        //                 </div>

        //                 <span className="hint d-block mt-1">Tap to flip back</span>
        //               </div>
        //             </div>
        //           </div>
        //         </div>
        //       );
        //     })}
        //   </div>
        // </div>

//         {/* --- DESKTOP/TABLET (≥ md): Bootstrap grid (unchanged) --- */}
//         <div className="row g-4 d-none d-md-flex">
//           {services.map((s) => (
//             <div key={s.slug} className="col-12 col-sm-6 col-lg-4">
//               <div className="card h-100 shadow-sm">
//                 <div className="card-body d-flex flex-column">
//                   <div className="d-flex align-items-center mb-2">
//                     <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
//                       <i className={`bi ${s.icon} text-primary-label fs-5`} aria-hidden="true"></i>
//                     </span>
//                     <h5 className="card-title mb-0">{s.title}</h5>
//                   </div>
//                   <p className="card-text text-muted flex-grow-1">{s.desc}</p>
//                   <div className="d-flex justify-content-end">
//                     <Link
//                       to={`/services/book/${s.slug}`}
//                       className="btn btn-outline-teal btn-sm"
//                       aria-label={`Book ${s.title}`}
//                     >
//                       Book Services
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default ServicesSection;

